import { Icons } from "../../../../icons/icons";

export const footerCopyByMode = {
  all: {
    middleTitle: "Cuidado integrado",
    description:
      "Estética e nutrição caminhando juntas para promover autoestima, bem-estar e resultados equilibrados.",
    ctaText: "Fale com a Dionara e agende seu atendimento com praticidade.",
    ctaButton: "Agendar no WhatsApp",
    whatsappMode: "all",
    highlights: [
      {
        title: "Bem-estar na rotina",
        text: "Cuidado completo para seu corpo, saúde e autoestima.",
        Icon: Icons.Heart,
      },
      {
        title: "Plano individual",
        text: "Estratégias personalizadas para o seu momento.",
        Icon: Icons.ClipboardCheck,
      },
      {
        title: "Cuidado próximo",
        text: "Acompanhamento humanizado em cada etapa.",
        Icon: Icons.User,
      },
    ],
  },

  aesthetics: {
    middleTitle: "Experiência estética",
    description:
      "Procedimentos pensados para valorizar sua beleza com naturalidade, segurança e acolhimento.",
    ctaText:
      "Fale com a Dionara e agende sua avaliação estética com praticidade.",
    ctaButton: "Agendar avaliação",
    whatsappMode: "aesthetics",
    highlights: [
      {
        title: "Naturalidade",
        text: "Resultados elegantes, equilibrados e harmônicos.",
        Icon: Icons.Sparkles,
      },
      {
        title: "Segurança",
        text: "Procedimentos com cuidado técnico e atenção aos detalhes.",
        Icon: Icons.Lock,
      },
      {
        title: "Acolhimento",
        text: "Atendimento próximo, leve e personalizado.",
        Icon: Icons.Heart,
      },
    ],
  },

  nutrition: {
    middleTitle: "Acompanhamento nutricional",
    description:
      "Foco em saúde, leveza, constância e estratégias adaptadas à sua rotina.",
    ctaText:
      "Fale com a Dionara e agende sua consulta nutricional com praticidade.",
    ctaButton: "Agendar consulta",
    whatsappMode: "nutrition",
    highlights: [
      {
        title: "Leveza na rotina",
        text: "Planos que se encaixam na sua vida.",
        Icon: Icons.Leaf,
      },
      {
        title: "Plano individual",
        text: "Estratégias personalizadas para seus objetivos.",
        Icon: Icons.ClipboardCheck,
      },
      {
        title: "Cuidado próximo",
        text: "Acompanhamento humanizado em cada etapa.",
        Icon: Icons.User,
      },
    ],
  },
};